'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventPrice = function (_Component) {
  _inherits(EventPrice, _Component);

  function EventPrice() {
    _classCallCheck(this, EventPrice);

    return _possibleConstructorReturn(this, (EventPrice.__proto__ || Object.getPrototypeOf(EventPrice)).apply(this, arguments));
  }

  _createClass(EventPrice, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currency = _props.currency,
          notes = _props.notes,
          type = _props.type,
          prices = _props.prices;

      var typeLabels = {
        FREE: 'Gratuit',
        DONATION: 'Contribution volontaire'
      };
      var sortedPrices = prices.slice().sort(function (a, b) {
        return Number.parseFloat(a.value) - Number.parseFloat(b.value);
      });

      if (type === 'FIXED' && prices.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'EventPrice' },
        typeLabels[type] && _react2.default.createElement(
          'span',
          { className: 'label' },
          typeLabels[type]
        ),
        type !== 'FREE' && prices.length > 0 && _react2.default.createElement(
          'ul',
          { className: 'prices' },
          sortedPrices.map(function (price) {
            return _react2.default.createElement(
              'li',
              { key: price.id },
              _react2.default.createElement(
                'strong',
                null,
                price.value,
                ' $',
                currency
              ),
              ' \u2013 ',
              price.description
            );
          })
        ),
        notes && _react2.default.createElement(
          'p',
          { className: 'notes' },
          notes
        )
      );
    }
  }]);

  return EventPrice;
}(_react.Component);

EventPrice.propTypes = {
  /** Three-letter currency code. */
  currency: _propTypes2.default.string,
  /** Notes about the price. */
  notes: _propTypes2.default.string,
  /** Price type: free, fixed, or PWYC. */
  type: _propTypes2.default.oneOf(['FREE', 'FIXED', 'DONATION']).isRequired,
  /** List of prices. */
  prices: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
EventPrice.defaultProps = {
  currency: null,
  notes: null,
  prices: []
};
exports.default = EventPrice;
EventPrice.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventPrice',
  'props': {
    'currency': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Three-letter currency code.'
    },
    'notes': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Notes about the price.'
    },
    'prices': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'object'
        }
      },
      'required': false,
      'description': 'List of prices.'
    },
    'type': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'FREE\'',
          'computed': false
        }, {
          'value': '\'FIXED\'',
          'computed': false
        }, {
          'value': '\'DONATION\'',
          'computed': false
        }]
      },
      'required': true,
      'description': 'Price type: free, fixed, or PWYC.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventPrice.js
// module id = 184
// module chunks = 0